module.exports = __webpack_public_path__ + "static/cheese-sm-d5e391e93e59565ac3cd83322c677579.jpg";